module.exports = __webpack_public_path__ + "img/0-108.50cbbc36.jpg";